<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer005">
<p class="tx-ni ParaOverride-1"><span class="com-rorohiko-pagestaker-style">ix</span></p>
<p class="ded" id="_idParaDest-3">To <span class="ital">Wonderful Walker</span></p>
<p class="ded">GoGo loves you</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Ded.vue?fff1a11e